/** Valores por defecto del formulario de alta/edición de colaboradores (COP). */
export const DEFAULT_MONTHLY_SALARY_COP = 2_000_000;
export const DEFAULT_MONTHLY_SALARY_COP_STR = String(DEFAULT_MONTHLY_SALARY_COP);

/** Valor YYYY-MM-DD para input type="date" (API, PostgreSQL o Excel). */
export function toInputDateValue(value) {
    if (value == null || value === '') return '';
    if (value instanceof Date) {
        if (Number.isNaN(value.getTime())) return '';
        const y = value.getUTCFullYear();
        const m = String(value.getUTCMonth() + 1).padStart(2, '0');
        const d = String(value.getUTCDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    }
    if (typeof value === 'object') return '';
    const s = String(value).trim();
    const iso = s.match(/^(\d{4}-\d{2}-\d{2})/);
    if (iso) return iso[1];
    const slash = s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
    if (slash) {
        let day = Number(slash[1]);
        let month = Number(slash[2]);
        const year = slash[3];
        if (day > 12 && month <= 12) {
            /* dd/mm/yyyy */
        } else if (month > 12 && day <= 12) {
            [day, month] = [month, day];
        }
        return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    }
    return '';
}

export function emptyEmployeeForm() {
    return {
        mode: 'create',
        id: null,
        id_document: '',
        employee_code: '',
        full_name: '',
        role: 'worker',
        area_id: '',
        supervisor_id: '',
        position: '',
        monthly_salary: DEFAULT_MONTHLY_SALARY_COP_STR,
        birth_date: '',
        hire_date: '',
        password: '',
    };
}

export function employeeFormFromRecord(emp) {
    const hasSalary =
        emp.monthly_salary != null && emp.monthly_salary !== '' && Number(emp.monthly_salary) > 0;
    return {
        mode: 'edit',
        id: emp.id,
        id_document: emp.id_document || '',
        employee_code: emp.employee_code || '',
        full_name: emp.full_name || '',
        role: emp.role || 'worker',
        area_id: emp.area_id != null ? String(emp.area_id) : '',
        supervisor_id: emp.supervisor_id != null ? String(emp.supervisor_id) : '',
        position: emp.position || '',
        monthly_salary: hasSalary ? String(emp.monthly_salary) : DEFAULT_MONTHLY_SALARY_COP_STR,
        birth_date: toInputDateValue(emp.birth_date),
        hire_date: toInputDateValue(emp.hire_date),
        password: '',
    };
}

export function buildCreateEmployeePayload(form) {
    const idDoc = form.id_document.trim();
    const code = form.employee_code.trim() || idDoc;
    const body = {
        id_document: idDoc,
        employee_code: code,
        full_name: form.full_name.trim(),
        role: form.role,
        area_id: Number(form.area_id),
        supervisor_id: form.supervisor_id ? Number(form.supervisor_id) : null,
        position: form.position.trim() || null,
        monthly_salary: form.monthly_salary === '' ? 0 : Number(form.monthly_salary),
        birth_date: form.birth_date.trim(),
        hire_date: form.hire_date.trim() || null,
    };
    if (form.role !== 'worker') {
        body.password = form.password;
    }
    return body;
}

/** Validación antes de enviar al API (evita bloqueo silencioso del navegador). */
export function validateRosterForm(form) {
    if (!form) return 'Formulario no disponible';
    const idDoc = String(form.id_document || '').trim();
    const name = String(form.full_name || '').trim();
    const birth = String(form.birth_date || '').trim();
    if (!idDoc) return 'El documento de identificación es obligatorio.';
    if (!name) return 'El nombre completo es obligatorio.';
    if (!birth) return 'La fecha de nacimiento es obligatoria.';
    if (!form.area_id) return 'Selecciona un área.';
    if (form.mode === 'create' && form.role !== 'worker') {
        const pwd = String(form.password || '');
        if (pwd.length < 6) return 'Contraseña inicial obligatoria (mín. 6 caracteres) para supervisor o admin.';
    }
    return null;
}

export function buildUpdateEmployeePayload(form) {
    return {
        full_name: form.full_name.trim(),
        employee_code: form.employee_code.trim(),
        id_document: form.id_document?.trim() || null,
        role: form.role,
        area_id: Number(form.area_id),
        supervisor_id: form.supervisor_id ? Number(form.supervisor_id) : null,
        is_active: 1,
        monthly_salary: form.monthly_salary === '' ? null : Number(form.monthly_salary),
        position: form.position.trim() || null,
        birth_date: form.birth_date?.trim() || null,
        hire_date: form.hire_date?.trim() || null,
    };
}
